/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * API specification of DataPointSelectionsAPI
 *
 * @class DataPointSelectionsAPISpec
 * @private
 * @hideconstructor
 * @classdesc
 */
define([], () => {
	class APISpec {
		getAPISpec() {
			if (!this.apiSpec) {
				this.apiSpec = {
					name: 'dataPointSelections API',
					events: {
						propagationInfo: {
							namespace: 'selections',
							info: {
								name: 'DataPointSelections'
							},
							callStack: {
								name: 'getFeature',
								params: ['DataPointSelections']
							}
						},
						actions: {
							/**
							 * @event DataPointSelectionsAPI#CanvasAPI change:content:selections:select
							 */
							/**
							 * @event DataPointSelectionsAPI#ContentAPI change:selections:select
							 */
							'select': {
								eventName: 'select',
								getUndoActions: (args) => [{
									name: 'deselect',
									params: [ args[0] ]
								}]
							},
							/**
							 * @event DataPointSelectionsAPI#CanvasAPI change:content:selections:deselect
							 */
							/**
							 * @event DataPointSelectionsAPI#ContentAPI change:selections:deselect
							 */
							'deselect': {
								eventName: 'deselect',
								getUndoActions: (args) => [{
									name: 'select',
									params: [args[0]]
								}]
							},
							/**
							 * @event DataPointSelectionsAPI#CanvasAPI change:content:selections:clearAll
							 */
							/**
							 * @event DataPointSelectionsAPI#ContentAPI change:selections:clearAll
							 */
							'clearAll': {
								eventName: 'clearAll',
								getUndoActions: () => [{
									name: 'select',
									params:[this.getSelections()]
								}]
							}
						}
					}
				};
			}
			return this.apiSpec;
		}
	}
	return APISpec;
});
